/**
 * @generated SignedSource<<b6fead71a46c73234ce47ce81872d506>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type routeHubMetaNameQuery$variables = {
  hubMetaName: string;
};
export type routeHubMetaNameQuery$data = {
  readonly hubMeta: {
    readonly city: string;
    readonly country: string;
    readonly hub: {
      readonly id: string;
      readonly products: {
        readonly nodes: ReadonlyArray<{
          readonly id: string;
          readonly " $fragmentSpreads": FragmentRefs<"ProductDrawerFragment">;
        }>;
      };
    };
    readonly id: string;
    readonly name: string;
    readonly organization: {
      readonly id: string;
      readonly supportEmail: string | null | undefined;
    };
    readonly postalCode: string;
    readonly street: string;
  };
};
export type routeHubMetaNameQuery = {
  response: routeHubMetaNameQuery$data;
  variables: routeHubMetaNameQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hubMetaName"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "hubMetaName"
      }
    ],
    "kind": "ObjectValue",
    "name": "by"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "active": true
    }
  },
  {
    "kind": "Literal",
    "name": "pagination",
    "value": {
      "page": 0,
      "pageSize": 1000000
    }
  }
],
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "Organization",
  "kind": "LinkedField",
  "name": "organization",
  "plural": false,
  "selections": [
    (v2/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "supportEmail",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "country",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postalCode",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "street",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "routeHubMetaNameQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v1/*:: as any*/),
          "concreteType": "HubMeta",
          "kind": "LinkedField",
          "name": "hubMeta",
          "plural": false,
          "selections": [
            (v2/*:: as any*/),
            {
              "kind": "RequiredField",
              "field": {
                "alias": null,
                "args": null,
                "concreteType": "Hub",
                "kind": "LinkedField",
                "name": "hub",
                "plural": false,
                "selections": [
                  (v2/*:: as any*/),
                  {
                    "alias": null,
                    "args": (v3/*:: as any*/),
                    "concreteType": "HubProductPage",
                    "kind": "LinkedField",
                    "name": "products",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "HubProduct",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v2/*:: as any*/),
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "ProductDrawerFragment"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "products(filter:{\"active\":true},pagination:{\"page\":0,\"pageSize\":1000000})"
                  }
                ],
                "storageKey": null
              },
              "action": "THROW"
            },
            (v4/*:: as any*/),
            (v5/*:: as any*/),
            (v6/*:: as any*/),
            (v7/*:: as any*/),
            (v8/*:: as any*/),
            (v9/*:: as any*/)
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "routeHubMetaNameQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "HubMeta",
        "kind": "LinkedField",
        "name": "hubMeta",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Hub",
            "kind": "LinkedField",
            "name": "hub",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": (v3/*:: as any*/),
                "concreteType": "HubProductPage",
                "kind": "LinkedField",
                "name": "products",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "HubProduct",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v2/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "priceAmount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "stock",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Product",
                        "kind": "LinkedField",
                        "name": "product",
                        "plural": false,
                        "selections": [
                          (v2/*:: as any*/),
                          (v5/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "description",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CloudflareImage",
                            "kind": "LinkedField",
                            "name": "photo",
                            "plural": false,
                            "selections": [
                              (v2/*:: as any*/),
                              {
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "variant",
                                    "value": "PUBLIC"
                                  }
                                ],
                                "kind": "ScalarField",
                                "name": "variant",
                                "storageKey": "variant(variant:\"PUBLIC\")"
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Brand",
                            "kind": "LinkedField",
                            "name": "brand",
                            "plural": false,
                            "selections": [
                              (v2/*:: as any*/),
                              (v5/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Organization",
                                "kind": "LinkedField",
                                "name": "organization",
                                "plural": false,
                                "selections": [
                                  (v2/*:: as any*/),
                                  (v5/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "imprint",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Category",
                            "kind": "LinkedField",
                            "name": "category",
                            "plural": false,
                            "selections": [
                              (v2/*:: as any*/),
                              (v5/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "i18N",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "products(filter:{\"active\":true},pagination:{\"page\":0,\"pageSize\":1000000})"
              }
            ],
            "storageKey": null
          },
          (v4/*:: as any*/),
          (v5/*:: as any*/),
          (v6/*:: as any*/),
          (v7/*:: as any*/),
          (v8/*:: as any*/),
          (v9/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "af1200bbc6bd520212ed0a2f04113edd",
    "id": null,
    "metadata": {},
    "name": "routeHubMetaNameQuery",
    "operationKind": "query",
    "text": "query routeHubMetaNameQuery(\n  $hubMetaName: String!\n) {\n  hubMeta(by: {name: $hubMetaName}) {\n    id\n    hub {\n      id\n      products(pagination: {page: 0, pageSize: 1000000}, filter: {active: true}) {\n        nodes {\n          id\n          ...ProductDrawerFragment\n        }\n      }\n    }\n    organization {\n      id\n      supportEmail\n    }\n    name\n    city\n    country\n    postalCode\n    street\n  }\n}\n\nfragment ProductDrawerFragment on HubProduct {\n  id\n  priceAmount\n  stock\n  product {\n    id\n    name\n    description\n    photo {\n      id\n      variant(variant: PUBLIC)\n    }\n    brand {\n      id\n      name\n      organization {\n        id\n        name\n        imprint\n      }\n    }\n    category {\n      id\n      name\n      i18N\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b753aa29b89122702f959a49ed75ab33";

export default node;
